module.exports = __webpack_public_path__ + "static/media/complaint.da4f55d6.png";


//////////////////
// WEBPACK FOOTER
// ./src/public/images/SSP/complaint.png
// module id = 65
// module chunks = 0